import IpubProgress from './src/main'

/* istanbul ignore next */
IpubProgress.install = function(Vue) {
  Vue.component(IpubProgress.name, IpubProgress)
}

export default IpubProgress
